/** Órdenes de prestación generadas desde una factura sanatorial (GET billhospitalization/getBenefitOrdersByBudget). */
export interface BillHospOrdersSummaryDTO {
    budget: number;
    patientName: string | null;
    patientDocument: string | null;
    /** Sin las órdenes anuladas. */
    totalHealthEntity: number;
    totalPatient: number;
    total: number;
    orders: BillHospOrderDTO[];
}

export interface BillHospOrderDTO {
    benefitOrder: number;
    /** yyyy-MM-dd */
    date: string | null;
    payerType: number | null;
    payerTypeName: string | null;
    state: number | null;
    stateName: string | null;
    nulled: boolean;
    issuerName: string | null;
    /** Obra social y plan, o paciente y documento. */
    destinationName: string | null;
    total: number;
    groups: BillHospOrderItemGroupDTO[];
}

export interface BillHospOrderItemGroupDTO {
    /** Código del tipo de ítem; null en "Otros". */
    itemType: number | null;
    itemTypeName: string;
    /** Si las líneas se dividen en honorarios y derechos: solo las prácticas; el resto es todo derechos. */
    feeSplit: boolean;
    subtotal: number;
    items: BillHospOrderItemDTO[];
}

export interface BillHospOrderItemDTO {
    benefitOrderDetail: number;
    code: string | null;
    description: string | null;
    quantity: number | null;
    unitPrice: number | null;
    medicalAmount: number;
    expensesAmount: number;
    total: number;
}

/** Estados de la orden de prestación que importan acá (benefitorderstate). */
export enum BenefitOrderStateId {
    PENDING_BILLING = 1,
    BILLED = 2,
    PAYED = 3,
    PENDING_REALIZATION = 4,
    NULLED = 51,
    REJECTED = 52,
}
